/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { AppBar } from '@veeam/components';
import React from 'react';
import { observer } from 'mobx-react-lite';

import type { AppBarProps } from '@veeam/components/lib/AppBar/types/AppBar.props';

import { useGlobalAppData } from '../providers/GlobalContextProvider';

export interface PortalHeaderProps extends AppBarProps {
}

export const PortalHeader: React.FC<PortalHeaderProps> = observer((props) => {
    const appPortalData = useGlobalAppData();

    return (
        <AppBar
            logo={appPortalData.portalLogoSrc}
            title={appPortalData.portalName}
            {...props}
        />
    );
});
